import { useCallback, useRef, useState } from "react";

export function useSubmitGuard<TData>(onSubmit: (data: TData) => unknown): {
	isSubmitting: boolean;
	guardedSubmit: (data: TData) => Promise<void>;
} {
	const [isSubmitting, setIsSubmitting] = useState(false);
	const inFlight = useRef(false);

	const guardedSubmit = useCallback(
		async (data: TData) => {
			if (inFlight.current) return;
			inFlight.current = true;
			setIsSubmitting(true);
			try {
				await onSubmit(data);
			} finally {
				inFlight.current = false;
				setIsSubmitting(false);
			}
		},
		[onSubmit],
	);

	return { isSubmitting, guardedSubmit };
}
